export default __webpack_public_path__ + "static/media/express.cf28d661.svg";